module.exports = __webpack_public_path__ + "fonts/CalibreBoldItalic.c9ffe690.woff";